import { Box, Grid, Typography } from '@mui/material';
import SegwareIcon from 'pages/LoginPage/SegwareIcon';
import React from 'react';
import { Outlet } from 'react-router-dom';
import LanguageSelect from './LanguageSelect';
import Layout from './Layout';
import background from 'assets/login-background.png';
import Logo from './Logo';
import dayjs from 'dayjs';

function LayoutLogin() {
  return (
    <Background>
      <TopBar />
      <Layout.Content sx={{ flexDirection: 'column' }}>
        <Box sx={{ flex: '1 1 auto', pt: 3 }}>
          <Grid container justifyContent="center" textAlign="center">
            <Grid item xs={12} md={6}>
              <Logo
                sx={{ width: '240px', height: '68px', mb: 5 }}
                sxCustomImage={{ maxWidth: '240px', height: '68px', mb: 5 }}
              />
              <Outlet />
            </Grid>
          </Grid>
        </Box>
        <Footer />
      </Layout.Content>
    </Background>
  );
}

function Background({ children }: { children: React.ReactNode }) {
  return (
    <Layout.Container>
      <Box
        sx={{
          backgroundImage: `url(${background})`,
          backgroundSize: 'contain',
          backgroundPosition: 'right',
          backgroundRepeat: 'no-repeat',
          backgroundColor: 'background.login',
          flex: '1 1 auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
    </Layout.Container>
  );
}

function TopBar() {
  return (
    <Box sx={{ textAlign: 'right', p: 4 }}>
      <LanguageSelect />
    </Box>
  );
}

function Footer() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        p: 4,
      }}
    >
      <Typography variant="subtitle1">
        {dayjs().year()} © My Security | Segware - All rights reserved
      </Typography>
      <SegwareIcon />
    </Box>
  );
}

export default LayoutLogin;
